import {Component, OnInit} from '@angular/core';
import {PrintingDesignformrule} from './printingDesignformrule';  
import {PrintingDesignservice} from '../services/printingDesignservice.service';

import { LocalStorageService } from 'angular-web-storage';

import { AppConstants  } from './../AppConstants';

import {Router} from '@angular/router';

@Component({
  selector: 'PrintingDesign',
  templateUrl: './PrintingDesign.component.html',
  styleUrls: ['../app.component.css'],
  providers: [PrintingDesignservice]
})

export class PrintingDesign implements OnInit {
    printingDesignformrule: PrintingDesignformrule[];

   commonUrl:string;
   projectId:string;
  apiKey:string;

  constructor(private router: Router,
              private printingDesignservice: PrintingDesignservice,
              private local: LocalStorageService) {
         this.commonUrl = AppConstants.commonUrl;
        this.projectId = AppConstants.projectId;
        this.apiKey = this.local.get('logedInUser').apiKey;

  }

  /**
   * Gets the existing users
   */
  getAll(): void {
    this.printingDesignservice.getAll()
      .then(printingDesignformrule => {
        console.log(printingDesignformrule);
        let response = JSON.parse(JSON.stringify(printingDesignformrule));
        this.printingDesignformrule = response.response;
      });
  }

  ngOnInit(): void {
    this.getAll();
  }

  update(id: string): void {
    this.router.navigate(['/printingDesignUpdate', id]);
  }

  remove(id: string): void {
    if(confirm("Are you sure to delete this")) {
      this.printingDesignservice.remove(id)
        .then(() => {
          this.getAll();
      });
    }
  }

  viewDetail(id: string): void {
    this.router.navigate(['/detail', id]);
  }


  
}
